var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIceCreamAlt1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.12536 5.00257C8.5685 3.27604 10.1352 2 12 2C13.8648 2 15.4315 3.27604 15.8746 5.00257C15.9162 5.00086 15.958 5 16 5C17.6569 5 19 6.34315 19 8C19 9.65685 17.6569 11 16 11C15.2316 11 14.5308 10.7111 14 10.2361C13.4692 10.7111 12.7684 11 12 11C11.2316 11 10.5308 10.7111 10 10.2361C9.46924 10.7111 8.76835 11 8 11C6.34315 11 5 9.65685 5 8C5 6.34315 6.34315 5 8 5C8.04199 5 8.08378 5.00086 8.12536 5.00257Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.89441 12.4988L11.0583 21.3378C11.3743 22.2207 12.6257 22.2207 12.9417 21.3378L16.1056 12.4988C16.0705 12.4996 16.0353 12.5 16 12.5C15.2823 12.5 14.6027 12.3312 14 12.0318C13.3973 12.3312 12.7177 12.5 12 12.5C11.2824 12.5 10.6027 12.3312 9.99999 12.0318C9.39726 12.3312 8.71764 12.5 7.99999 12.5C7.9647 12.5 7.9295 12.4996 7.89441 12.4988Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIceCreamAlt1);
export default __webpack_public_path__ + "static/media/ice-cream-alt-1.1cd7764c48538704f2e2f19715e8d8e2.svg";
export { ForwardRef as ReactComponent };